// TODO: Substitute with helper function definition in Natahs PR that will be merged soon
export const delay = (ms: number) =>
  new Promise((res) => {
    setTimeout(res, ms);
  });
